// @flow
import React from 'react';
import {ButtonPrimary} from '@homeaway/react-buttons';
import noResultsIcon from '../NoResultsBanner/no-results.svg';

import './NoResultsBanner.less';

import type {Node} from 'react';

type Props = {
    title: Node,
    description: Node,
    buttonLabel: Node,
    buttonHandler: Function
};

export function NoResultsBanner({
    title,
    description,
    buttonLabel,
    buttonHandler
}: Props) {
    return (
        <div className="NoResultsBanner media-flex media-flex--right media-flex--xs">
            <figure className="media-flex__figure">
                <img src={noResultsIcon()} alt="no results" />
            </figure>
            <div className="media-flex__content">
                <div className="media-flex__body">
                    <h2>{title}</h2>
                    <div className="NoResultsBanner-description">
                        {description}
                    </div>
                </div>
                <div className="media-flex__footer">
                    <ButtonPrimary
                        size="sm"
                        id={'noResultsBanner'}
                        label={buttonLabel}
                        onClick={buttonHandler}
                    />
                </div>
            </div>
        </div>
    );
}

export default NoResultsBanner;
